import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';

import CreateAccountForm from './components/CreateAccountForm';
import Message from './components/Message';

const CreateAccount = (props) => {
  const { settings } = props;
  if (!settings.data) {
    return (
      <Layout title="Create An Account" loading>
        <Title>Create New Account</Title>
      </Layout>
    );
  }
  return (
    <Layout title="Create An Account">
      <Title>Create New Account</Title>
      <Message settings={settings} />
      <CreateAccountForm forwardTo="/profile" />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps)(CreateAccount);
